import { useState } from "react";
import { useDispatch } from 'react-redux';

import authApi from "../../api/authApi";
import AlertModal from "../Commons/AlertModal";
import { resetAuth } from "../../slices/authSlice";
import Global from "../../Global/Global";

import { getLabel } from "../../tools/Dictionary";

import logo from "../../images/Innovair_logo.png";

const AuthToVerify = (props) =>
{

  //Redux
  const Dispatch = useDispatch();

  //Variables
  const component = "AuthToVerify";

  //State
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Send verification email
  const onClickSend = async() =>
  {
    try{

      setLoading(true);

      let response = await authApi.sendVerificationEmail();

      setLoading(false);

      if (!response.Success){


        setAlert({
          Title: getLabel("App", "Error"),
          Message: getLabel(response.Error.component, response.Error.label) || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
          Display: true
        });

        return;
      }

      setAlert({
        Title: getLabel(component, "Verification Email Sent"),
        Message: getLabel(component, "Verification Email Sent: We have sent..."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }catch(err){

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });
    }
  };

  const onClickHome = () => {

    Dispatch(resetAuth());
    localStorage.setItem(Global.apiToken, "");
    localStorage.setItem(Global.apiTokenAI, "");

    authApi.setRequestHeader("EN");



  }

  return (
    <div className="auth_page_cont">
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <div className="auth_page_title">
        <img src={logo} alt="logo" style={{ width: "50%" }} />
      </div>
      <div className="auth_cont" style={{ minHeight: "340px" }}>
        <div className="auth_cont_title">
          {getLabel(component, "Email Verification")}
        </div>
        <div className="auth_cont_body">
          <div className="auth_verify_text">
            {getLabel(component, "Email Verification Pending: Please check your mailbox...")}
          </div>
        </div>
        <div className="auth_fill_footer" style={{ marginTop: "10px" }}>
          <input
            type="button"
            className="page_button auth_cont_login_button"
            value={getLabel(component, "Resend Verification Email")}
            style={{ backgroundColor: "#5ba644"}}
            onClick={onClickSend}
            disabled={loading}
          />
          <input
            type="button"
            className="page_button auth_cont_login_button"
            value={getLabel("App", "Home")}
            style={{marginTop: "20px"}}
            onClick={onClickHome}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );


}

export default AuthToVerify;